import { IModalService, IModalSettings } from "angular-ui-bootstrap";
import {OTReportDialog} from "./component/OpenTraderReportDialogComponent";
import {AccountId} from "../../../../account/types/AccountRecord";

export class OpenTraderReportsDialog {

    public static readonly id = "openTraderReportsDialog";

    /** @ngInject */
    public constructor(private readonly $uibModal: IModalService) {
    }

    public async open(accountId: AccountId): Promise<void> {
        const settings: IModalSettings = {
            component: OTReportDialog,
            resolve: {
                accountId: () => accountId
            }
        };
        const instance = this.$uibModal.open(settings);
        return instance.result;
    }
}
